import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'biz-encryption',
  templateUrl: './encryption.component.html',
  styleUrls: ['./encryption.component.scss']
})
export class EncryptionComponent implements OnInit {
  public selectedTab: number = 0;
  constructor(
  ) {

  }

  ngOnInit(): void {
  }

}
